import * as preact from 'preact'
const { h, Component } = preact

interface Props {
  sendGaEvent: (eventObj: {}) => void
  sendError: (message: string) => void
  children: Array<any>
}

class Provider extends Component<Props> {
  getChildContext () {
    const { children, ...props } = this.props
    return { '__CTX__': props }
  }
  render () {
    if (this.props.children && this.props.children[0]) {
      return this.props.children[0]
    }
  }
}

Provider.displayName = 'Provider'

function connect (mapContextToProps?: (obj:Object) => Object) {
  return (wrappedComponent: any) => {
    class Connected extends Component<{}, {}> {
      mapContextToProps = (ctx: Object): Object => {
        return mapContextToProps ? mapContextToProps(ctx) : ctx
      }
      render () {
        return h(wrappedComponent, {
          ...this.mapContextToProps(this.context['__CTX__']),
          ...this.props
        })
      }
    }
    Connected.displayName = `connect(${wrappedComponent.displayName ||
      wrappedComponent.name ||
      'Component'})`
    return Connected
  }
}

export { Provider, connect }
